import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Blog } from '../shared/models/Blog';
import moment from 'moment';
import { Survey } from 'src/app/shared/models/Survey';
import { SurveyAnswer } from 'src/app/shared/models/SurveyAnswer';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../shared/http-utils';

@Injectable({
  providedIn: 'root'
})
export class BlogsService {

  constructor(private _http: HttpClient) { }

  public getBlogs(): Observable<Blog[]> {
    const headers = HttpUtils.createHeaders();
    return this._http.get(environment.URL_BASE + '/admin/blogs/get', { headers }).pipe(
      map((result: any[]) => result.map(res => Blog.fromDto(res)))
    );
  }

  public saveBlog(blog: Blog): Observable<any> {
    const headers = HttpUtils.createHeaders();
    return this._http.put(environment.URL_BASE + '/admin/blog/save', { blog: blog }, { headers }).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  public uploadBlogImage(formData: FormData): Observable<any> {
    const headers = HttpUtils.createHeaders();
    return this._http.post(environment.URL_BASE + '/admin/blog/uploadImage', formData, {headers}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  public publishBlog(blogId: string): Observable<any> {
    const headers = HttpUtils.createHeaders();
    return this._http.post(environment.URL_BASE + '/admin/blog/publish', { blogId: blogId }, { headers }).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  public deleteBlog(blogId: string): Observable<any> {
    const headers = HttpUtils.createHeaders();
    return this._http.post(environment.URL_BASE + '/admin/blog/delete', { blogId: blogId }, { headers }).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

}
